import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import { EffectRainType, ImageType, type SceneEffect } from '@types';
import Image from '@components/Image';
import IconTrash from '@components/icons/IconTrash';
import { isRainEffect, isSunlightEffect } from '../utils/effectTypeCheck';
import { RAIN_TYPE_CONFIG } from '../constants';

interface Props {
  data: SceneEffect;
  onClick: (data: SceneEffect) => void;
  onDeleteClick: (id: string) => void;
}

export const SidebarEffectItem = SortableElement(
  ({ data, onClick, onDeleteClick }: Props) => {
    const isSunlight = isSunlightEffect(data);
    const isRain = isRainEffect(data);

    const renderIcon = () => {
      if (isSunlight) {
        return (
          <Image
            src="/imgs/e-icon-sl.ffd3fbd73b9d417abd50ff441db213cf.png"
            type={ImageType.sysMedia}
            className="h-16 w-16"
          />
        );
      }
      if (isRain) {
        if (data.rainType === EffectRainType.custom) {
          return (
            <Image
              src={data.mediaUrl ?? ''}
              type={ImageType.media}
              className="h-16 w-16"
            />
          );
        }
        return (
          <Image
            src={RAIN_TYPE_CONFIG[data.rainType].icon}
            type={ImageType.sysMedia}
            className="h-16 w-16"
          />
        );
      }
    };

    const renderTitle = () => {
      if (isSunlight) return '太阳光';
      if (isRain) return RAIN_TYPE_CONFIG[data.rainType].name;
    };

    return (
      <div
        className="mb-10 flex h-35 w-full cursor-pointer items-center rounded bg-black-#28 px-10 hover:bg-black-#34"
        onClick={() => onClick(data)}
      >
        {renderIcon()}
        <div className="mx-10 truncate text-base text-white">
          {renderTitle()}
        </div>
        <IconTrash
          className="ml-auto"
          onClick={(e) => {
            e.stopPropagation();
            onDeleteClick(data.id);
          }}
        />
      </div>
    );
  }
);
